'use client';

import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

type FooterLatestContentProps = {
  latestArticles: ReactNode;
  latestProjects: ReactNode;
};

export const FooterLatestContentComponent = ({ latestArticles, latestProjects }: FooterLatestContentProps) => {
  const pathname = usePathname();
  const normalizedPathname = pathname?.replace(/\/+$/, '') || '/';

  return normalizedPathname === '/articles' ? latestProjects : latestArticles;
};
